<template>
    <div>
        <v-card shaped class="pa-3 ma-md-3">
            <v-toolbar flat color="#1d2735" dark>
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <v-toolbar-title
                    ><h3 style="overflow-wrap: normal">
                        Libro IVA
                    </h3></v-toolbar-title
                >
            </v-toolbar>

            <v-container class="mt-3">
                <v-col cols="12">
                    <v-row>
                        <v-col cols="8">
                            <h3 class="text-left">
                                IVA 303 Trimestral
                            </h3>
                        </v-col>
                        <v-col>
                            <div class="m-0">
                                <v-select label="Seleccionar Año" @change="getDatos()" :items="anio_iva" v-model="anio_iva_selected" small class="text-right" />
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-divider class="m-2"></v-divider>
                <v-row class="mt-3 w-100">
                    <v-col>
                        <div class="font-weight-bold">
                            Periodo
                        </div>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold text-right">
                            IVA Soportado
                        </div>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold text-right">
                            IVA Repercutido
                        </div>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold text-right">
                            Resultado Iva
                        </div>
                    </v-col>
                </v-row>

                <v-row >
                    <v-col class="text-left" >
                        1er. Semestre
                    </v-col>
                    <v-col v-for="(impuesto, index) in semestreUno" :key="index" class="text-right" >
                        {{ (impuesto > 0 ? impuesto : "0.00") | format_precio }}
                    </v-col>
                </v-row>
                <v-row >
                    <v-col class="text-left" >
                        2do. Semestre
                    </v-col>
                    <v-col v-for="(impuesto, index) in semestreDos" :key="index" class="text-right" >
                        {{ (impuesto > 0 ? impuesto : "0.00") | format_precio }}
                    </v-col>
                </v-row>

                <v-row >
                    <v-col class="text-left" >
                        3er. Semestre
                    </v-col>
                    <v-col v-for="(impuesto, index) in semestreTres" :key="index" class="text-right" >
                        {{ (impuesto > 0 ? impuesto : "0.00" ) | format_precio}}
                    </v-col>
                </v-row>

                <v-row >
                    <v-col class="text-left" >
                        4to. Semestre
                    </v-col>
                    <v-col v-for="(impuesto, index) in semestreCuatro" :key="index" class="text-right" >
                        {{( impuesto > 0 ? impuesto : "0.00" ) | format_precio}}
                    </v-col>
                </v-row>

            </v-container>

            <v-container class="mt-3">
                <v-divider class="m-2"></v-divider>
                <v-row class="mt-3 w-100">
                    <v-col cols="12">
                        <h3 class="text-left">
                            Resumen de Impuestos
                        </h3>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold">
                            Ventas
                        </div>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold text-right">
                            Sub Total
                        </div>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold text-right">
                            Importe
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-left">IVA 21%</v-col>
                    <v-col class="text-right">{{ sub_total_ventas | format_precio }}</v-col>
                    <v-col class="text-right">{{ importe_ventas | format_precio }}</v-col>
                </v-row>
                <v-row class="mt-3 w-100">
                    <v-col>
                        <div class="font-weight-bold">
                            Compras
                        </div>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold text-right">
                            Sub Total
                        </div>
                    </v-col>
                    <v-col>
                        <div class="font-weight-bold text-right">
                            Importe
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-left">IVA 21 %</v-col>
                    <v-col class="text-right">{{ sub_total_compras | format_precio }}</v-col>
                    <v-col class="text-right">{{ importe_compras | format_precio }}</v-col>
                </v-row>
            </v-container>

        </v-card>
    </div>
</template>

<script>
// import { debounce } from "../../../helpers";
export default {
    data() {
        return {
            // agentes: [],
            anio_iva_selected: new Date().getFullYear(),
            semestreUno: [],
            semestreDos: [],
            semestreTres: [],
            semestreCuatro: [],
            sub_total_ventas: '',
            sub_total_compras: '',
            importe_ventas : '',
            importe_compras : '',
            anio_iva: [new Date().getFullYear()],
            calculo_iva: []
        };
    },
    created() {
        // this.getEstadosPotencial();
        this.rol = localStorage.getItem("role");
        // this.getAgentes();
        this.getDatos();
        this.getAnios();
    },
    watch: {
        "$route.meta.rol": function (val) {
            this.getDatos();
            this.getAnios();
        },
        "filtros.validacion": function (val) {
            this.getDatos();
            this.getAnios();
        },
    },
    methods: {
        // Get apuntes contables para IVA

        getDatos() {

            axios
                .get(
                    `api/get-reporte-iva/${this.anio_iva_selected}`
                )
                .then(
                    (res) => {
                        if(res.data.code == 200){

                            this.semestreUno = [
                                parseFloat(res.data.success.semestreUno[0].total_iva_soportado).toFixed(2),
                                parseFloat(res.data.success.semestreUno[0].total_iva_repercutido).toFixed(2),
                                parseFloat(res.data.success.semestreUno[0].total_iva_repercutido - res.data.success.semestreUno[0].total_iva_soportado).toFixed(2)
                            ]

                            this.semestreDos = [
                                parseFloat(res.data.success.semestreDos[0].total_iva_soportado).toFixed(2),
                                parseFloat(res.data.success.semestreDos[0].total_iva_repercutido).toFixed(2),
                                parseFloat(res.data.success.semestreDos[0].total_iva_repercutido - res.data.success.semestreDos[0].total_iva_soportado).toFixed(2)
                            ]

                            this.semestreTres = [
                                parseFloat(res.data.success.semestreTres[0].total_iva_soportado).toFixed(2),
                                parseFloat(res.data.success.semestreTres[0].total_iva_repercutido).toFixed(2),
                                parseFloat(res.data.success.semestreTres[0].total_iva_repercutido - res.data.success.semestreTres[0].total_iva_soportado).toFixed(2)
                            ]

                            this.semestreCuatro = [
                                parseFloat(res.data.success.semestreCuatro[0].total_iva_soportado).toFixed(2),
                                parseFloat(res.data.success.semestreCuatro[0].total_iva_repercutido).toFixed(2),
                                parseFloat(res.data.success.semestreCuatro[0].total_iva_repercutido - res.data.success.semestreCuatro[0].total_iva_soportado).toFixed(2)
                            ]

                            this.sub_total_ventas = res.data.success.sub_total_ventas
                            this.sub_total_compras = res.data.success.sub_total_compras

                            this.importe_ventas = parseFloat(res.data.success.semestreUno[0].total_iva_repercutido + res.data.success.semestreDos[0].total_iva_repercutido + res.data.success.semestreTres[0].total_iva_repercutido + res.data.success.semestreCuatro[0].total_iva_repercutido).toFixed(2)

                            this.importe_compras = parseFloat(res.data.success.semestreUno[0].total_iva_soportado + res.data.success.semestreDos[0].total_iva_soportado + res.data.success.semestreTres[0].total_iva_soportado + res.data.success.semestreCuatro[0].total_iva_soportado).toFixed(2)

                        }else{
                            this.$custom_error("Error consultando IVA")
                        }
                    },
                    (err) => {
                        this.$custom_error(err.response.data.error);
                    }
                );
        },

        getAnios() {

            axios
                .get(
                    `api/get-anios-iva`
                )
                .then(
                    (res) => {
                        if(res.data.code == 200){
                            console.log(res.data.success)
                            this.anio_iva = res.data.success
                            console.log(this.anio_iva)
                        }else{
                            this.$custom_error("Error consultando años contables")
                        }
                    },
                    (err) => {
                        this.$custom_error(err.response.data.error);
                    }
                );
            },
    },
};
</script>


<style scoped>
</style>
